import { useState } from 'react';
import { Link } from 'react-router-dom';
import { homeFaqs } from '@/mocks/home';

export default function HomeFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <span className="font-heading text-sm tracking-widest text-secondary-700">常见问题</span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
            投稿入口怎么用
          </h2>
          <p className="mt-5 text-sm md:text-base leading-7 text-foreground-600">
            先在这里找到答案，再决定要不要留下联系方式。如果还有疑问，也可以在投稿表单里直接写出来。
          </p>
          <Link
            to="/guide"
            className="mt-7 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-secondary-500 text-background-50 text-sm font-bold hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line text-base"></i>
            查看完整投稿指南
          </Link>
        </div>

        <div className="lg:col-span-8">
          <ul className="flex flex-col gap-3">
            {homeFaqs.map((f, i) => {
              const open = openIndex === i;
              return (
                <li key={f.q} className="rounded-lg bg-background-100 border border-background-200 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : i)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 px-5 py-5 text-left cursor-pointer hover:bg-background-200/60 transition-colors"
                  >
                    <h3 className="text-base font-bold text-foreground-950">{f.q}</h3>
                    <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className={open ? 'ri-subtract-line text-lg' : 'ri-add-line text-lg'}></i>
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-7 text-foreground-600 border-t border-background-200 pt-4">{f.a}</p>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}